import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { ELTooltip } from '@davincihealthcare/elty-design-system-react';
import { formatReservationPrice } from '@/app/(checkout)/_utils/checkout';

export const PriceSection = ({
  hasDynamicPrice,
  isLicensedClinic,
  price,
  hasAvailableSlots,
}: {
  hasDynamicPrice: boolean;
  price?: number;
  isLicensedClinic: boolean;
  hasAvailableSlots: boolean;
}) => {
  const canShowPriceInfo = hasDynamicPrice;
  const title = hasDynamicPrice ? 'a partire da' : 'prezzo';
  const isPriceAvailable = typeof price === 'number'; // Price 0 is ok

  return (
    <div className="flex items-center">
      {isPriceAvailable && isLicensedClinic ? (
        <div className="flex flex-col gap-1.5 text-nowrap md:gap-0.5">
          <span className="w-full text-center text-sm font-medium text-neutral-lighter md:text-base">{title}</span>
          <div className="flex h-full shrink-0 items-center gap-1 text-sm font-normal text-neutral-darker">
            <p className={`text-2xl font-medium ${hasAvailableSlots ? 'text-primary-active' : 'text-neutral-inactive'} md:text-3xl`}>
              {formatReservationPrice(price)}&nbsp;&#8364;
            </p>

            {canShowPriceInfo && (
              <span className="flex h-full" data-cy="price-info-tooltip">
                <ELTooltip
                  text={'Il prezzo potrebbe variare in base al giorno o orario scelto'}
                  position="top-left"
                  className="w-52 text-wrap md:w-60"
                >
                  <InformationCircleIcon className={`h-5 w-5 ${hasAvailableSlots ? 'text-primary-active' : 'text-neutral-inactive'}`} />
                </ELTooltip>
              </span>
            )}
          </div>
        </div>
      ) : (
        'Prezzo non disponibile'
      )}
    </div>
  );
};
